import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import dayjs from 'dayjs'
import { yupResolver } from '@hookform/resolvers/yup'
import { toast } from 'react-toastify'
import { withTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import images from 'assets/img'
import * as validations from './validation'
import { apiRequest } from 'store/Misc/apiRequest'
import { setFormLoading } from 'store/slices/miscSlice'
import LinkItem from 'components/Link'
import LoginForm from './forms/LoginForm'
import { destructureErrorMessage } from 'Helper'
import RegistrationForm from './forms'
import ForgotPassword from './forms/ForgotPassword'
import { Grid } from '@mui/material'
import { withRouter } from 'hooks/withRouter'

const validationFields = [
  'BusinessRegisteratinValidation',
  'ContactPersonValidation',
  'PasswordValidation'
]


export default withTranslation()(withRouter(function Registration({ t, router: { navigate } }) {

  const [step, setstep] = useState(0)
  const dispatch = useDispatch()
  const pathname = window.location.pathname

  const method = useForm({
    mode: 'all',
    resolver: pathname !== '/register' ? pathname !== '/login' ? yupResolver(validations.LoginValidation) : yupResolver(validations.EmailValidation) : yupResolver(validations[validationFields[step]])
  })

  const { handleSubmit, formState: { isValid, isDirty } } = method


  const submit = async (payload) => {
    const { name, primary_phone, primary_email, country_id, category_id } = payload
    const { first_name, last_name, phone, email, password, password_confirmation } = payload

    dispatch(setFormLoading())

    try {
      let data = await apiRequest({
        method: 'post',
        url: pathname === '/register' ? 'merchants/setup' : 'auth/login',
        payload: pathname === '/register' ? {
          merchant: { name, primary_phone, primary_email, country_id, category_id },
          user: { first_name, last_name, phone, email, password, password_confirmation }
        } : payload,
        // action: pathname === '/register' ? null : auth
      })

      if (data) {
        if (pathname === '/login') {
          localStorage.setItem('__ra_pos', data.data.access_token)
          localStorage.setItem('__ra_pos_refresh', data.data.refresh_token)
          localStorage.setItem('merchant_id', data.data.user.id)

          if (data.data.access_token && data.data.refresh_token) navigate('/overview')
        }
        else if (pathname === '/register') {
          toast.success(t('registration.success'))
          navigate('/login')
        }
      }
    } catch ({ message }) {
      destructureErrorMessage(message).map(msg => {
        return toast.error(t(msg), { autoClose: 15000 })
      })
    }
    dispatch(setFormLoading('close'))
    return
  }


  const pageSwitcher = (name) => {
    switch (name) {
      case '/login':
        return <LoginForm yupFields={{ isDirty, isValid }} />

      case '/register':
        return <RegistrationForm yupFields={{ isDirty, isValid }} steps={{ step, setstep }} validationFields={validationFields} />

      case '/forgot-password':
        return <ForgotPassword yupFields={{ isDirty, isValid }} />

      default:
        return
    }
  }


  return (
    <div className="mx-auto h-screen overflow-hidden relative" style={{ backgroundImage: `url('${images.logo}')` }}>
      {/* <img src={images.Logo} alt="" className="w-40" /> */}

      <Grid container className="w-full flex bg-form-bg h-full bg-[#183552] flex items-center bg-no-repeat bg-center bg-cover">
        <FormProvider {...method}>
          <Grid component={'form'} item xs={12} lg={4}
            className="item-center text-center px-5 flex flex-col items-center justify-center mx-auto border rounded-lg !bg-[white] h-[fit-content] py-4"
            onSubmit={handleSubmit(submit)}>
            <img src={images.Logo} alt="" className="w-40" />
            {
              pageSwitcher(pathname)
            }
          </Grid>
        </FormProvider>

        {/* <div className={`w-1/2 h-auto lg:flex item-center jusify-center hidden`}>
        </div> */}
      </Grid>

      <div className="w-full text-center absolute bottom-[8%] p-5 flex justify-between lg:block">
        <LinkItem url="/forgot-password"
          tag={() => <span className="text-secondary font-medium inline-block lg:mr-20">{t('registration.tc')}</span>} />
        <span className="text-secondary font-medium">&copy; {dayjs().format('YYYY')} ReachAfrika LLC</span>
      </div>
    </div>
  )
}))





// const pageSwitcher = (name) => {

//   switch (name) {
//     case '':
//       return <StepOne />

//     case '/register':
//       return <StepTwo />

//     case '/forgot-password':
//       return <StepThree />

//     default:
//       return
//   }
// }